import React from 'react';

import "./loadingspinner.css";

const LoadingSpinner = () => {
  //  <span className="loader" /> 
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '70vh' }}>
      <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  )


}

export default LoadingSpinner;